import axios from "axios";
import { IAutoRegistrationValues } from "./types";


export const registrationApi = {
  postAutoRegistration: (values: IAutoRegistrationValues) => {
    return axios.post('/registration/', values)
  },
}